/* rr-portfolio-case.js (REWRITE)
   Fixes:
   - Duplication ONLY when auto is enabled for the CURRENT breakpoint
   - If manual-only is enabled, clones are REMOVED (no duplicates)
   - RAF only runs when auto is enabled for current breakpoint + motion allowed
   - Seamless loop uses modulo half-width
   - Pause on hover / interaction
*/

(function () {
  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
  }

  function isMobile() {
    return !!(window.matchMedia && window.matchMedia("(max-width: 990px)").matches);
  }

  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function parseBool(v) {
    return String(v) === "true";
  }

  function initRail(sectionEl) {
    const rail = sectionEl.querySelector("[data-rr-rail]");
    if (!rail) return;

    const track = rail.querySelector("[data-rr-rail-track]");
    if (!track) return;

    const desktopLoopSeconds = parseFloat(rail.dataset.desktopLoopSeconds || "22");
    const mobilePxPerSec = parseFloat(rail.dataset.mobilePxPerSec || "20");

    let rafId = null;
    let lastTs = 0;
    let offset = 0;
    let paused = false;

    function getBaseItems() {
      return Array.from(track.children).filter((el) => !el.hasAttribute("data-rr-clone"));
    }

    function getClones() {
      return Array.from(track.children).filter((el) => el.hasAttribute("data-rr-clone"));
    }

    function currentAutoEnabled() {
      const m = isMobile();
      return m ? parseBool(rail.dataset.mobileAuto) : parseBool(rail.dataset.desktopAuto);
    }

    function currentManualEnabled() {
      const m = isMobile();
      return m ? parseBool(rail.dataset.mobileManual) : parseBool(rail.dataset.desktopManual);
    }

    function autoAllowedNow() {
      return currentAutoEnabled() && !prefersReducedMotion();
    }

    function applyModeClasses() {
      const manual = currentManualEnabled();
      const auto = autoAllowedNow();

      rail.classList.toggle("is-manual", manual);
      rail.classList.toggle("is-auto", auto);

      if (!auto) {
        track.style.transform = "";
      }
    }

    function removeClones() {
      const clones = getClones();
      clones.forEach((c) => c.remove());
      track.dataset.duplicated = "";
    }

    function ensureDuplicationForAuto() {
      // Only duplicate for auto mode (current breakpoint).
      if (!autoAllowedNow()) return;

      const items = getBaseItems();

      // Need at least 2 items for a believable loop.
      if (items.length < 2) return;

      if (track.dataset.duplicated === "true") return;

      const frag = document.createDocumentFragment();
      items.forEach((it) => {
        const clone = it.cloneNode(true);
        clone.setAttribute("data-rr-clone", "true");
        frag.appendChild(clone);
      });

      track.appendChild(frag);
      track.dataset.duplicated = "true";
    }

    function halfWidth() {
      const total = track.scrollWidth;
      if (!total) return 0;
      return total / 2;
    }

    function computeSpeedPxPerSec(half) {
      if (isMobile()) {
        return clamp(mobilePxPerSec, 5, 120);
      }
      const loop = clamp(desktopLoopSeconds, 6, 180);
      return half / loop;
    }

    function tick(ts) {
      if (!lastTs) lastTs = ts;
      const dt = (ts - lastTs) / 1000;
      lastTs = ts;

      const auto = autoAllowedNow();

      if (!auto) {
        stop();
        applyModeClasses();
        return;
      }

      if (!paused) {
        const half = halfWidth();
        if (half > 0) {
          const speed = computeSpeedPxPerSec(half);
          offset += speed * dt;

          if (offset >= half) offset -= half;
          if (offset < 0) offset = 0;

          track.style.transform = `translate3d(${-offset}px, 0, 0)`;
        }
      }

      rafId = window.requestAnimationFrame(tick);
    }

    function start() {
      if (rafId) return;
      lastTs = 0;
      rafId = window.requestAnimationFrame(tick);
    }

    function stop() {
      if (!rafId) return;
      window.cancelAnimationFrame(rafId);
      rafId = null;
    }

    function refresh() {
      applyModeClasses();

      if (autoAllowedNow()) {
        // Auto mode: ensure clones exist for seamless loop.
        ensureDuplicationForAuto();

        const half = halfWidth();
        offset = half > 0 ? (offset % half) : 0;

        start();
      } else {
        // Manual-only (or reduced motion): remove clones + stop RAF.
        stop();
        removeClones();
        offset = 0;
        track.style.transform = "";
      }
    }

    /* ----------------------------
       Pause behavior
    ----------------------------- */

    rail.addEventListener("mouseenter", () => {
      if (!isMobile()) paused = true;
    });
    rail.addEventListener("mouseleave", () => {
      if (!isMobile()) paused = false;
    });

    rail.addEventListener("touchstart", () => { paused = true; }, { passive: true });
    rail.addEventListener("touchend", () => { paused = false; }, { passive: true });

    rail.addEventListener("pointerdown", () => { paused = true; });
    rail.addEventListener("pointerup", () => { paused = false; });
    rail.addEventListener("pointercancel", () => { paused = false; });

    /* ----------------------------
       Init + resize handling
    ----------------------------- */

    refresh();

    let resizeTimer = null;
    window.addEventListener("resize", () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => {
        refresh();
      }, 120);
    });

    const obs = new MutationObserver(() => {
      if (!document.body.contains(sectionEl)) {
        stop();
        obs.disconnect();
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  function initAll() {
    document.querySelectorAll("[data-rr-case-section]").forEach((sectionEl) => {
      initRail(sectionEl);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (e) => {
    if (!e.target) return;
    const sectionEl = e.target.querySelector("[data-rr-case-section]");
    if (sectionEl) initRail(sectionEl);
  });
})();
